import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getHeaderWiseReport,
    getHeaderWiseReportCancelToken } from '../../../actions/products/reports';
import PropTypes from 'prop-types';
import ProductSummaryListItem from './ProductSummaryListItem';

function ProductSummaryListView({ headers,
    getHeaderWiseReport,
    productId,
    isPublic,
    reports,
    publicClickAction,
    token }) {
    function handleClick(headerId) {
        if (!headerId || reports.fetching) return;
        getHeaderWiseReport(token,
            productId,
            headerId);
    }
    useEffect(() => {
        return function cleanup() {
            if (getHeaderWiseReportCancelToken) getHeaderWiseReportCancelToken();
        }
    }, []);
    if (!headers || (headers && !headers.length)) return null;
    const listItems = headers.map((header, index) => <ProductSummaryListItem
        header={header}
        isPublic={isPublic}
        handleClick={isPublic ? publicClickAction : handleClick}
        key={`header-${index}`} />)
    return (<ul className="product__reports__list">{listItems}</ul>)
}

ProductSummaryListView.propTypes = {
    headers: PropTypes.array.isRequired,
    productId: PropTypes.string.isRequired,
    isPublic: PropTypes.bool,
    publicClickAction: PropTypes.func
}

function mapStateToProps(state) {
    return {
        token: state.login.token,
        reports: state.productReducer.reports
    }
}

const mapDispatchToProps = {
    getHeaderWiseReport
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductSummaryListView);